import { Flex } from '@chakra-ui/react';

type Props = {
  label: string;
};

export const NabanItemBadge = ({ label }: Props) => (
  <Flex
    borderColor='neutral100'
    borderWidth={1}
    borderRadius='.15rem'
    fontSize='.75rem'
    lineHeight='110%'
    color='neutral600'
    p={1.5}
    textTransform='uppercase'>
    {label}
  </Flex>
);
